﻿/* eslint-disable no-undef */
var resetSidebarScroll = function () {
	// sidebar - scroll container
	$(".slimscroll-menu").slimscroll({
		height: "auto",
		position: "right",
		size: "8px",
		color: "#9ea5ab",
		wheelStep: 5,
		touchScrollStep: 20
	});
};
window.onload = function () {
	// Left menu collapse
	$(".button-menu-mobile").on("click", function (event) {
		event.preventDefault();
		$("body").toggleClass("sidebar-enable");
		if ($(window).width() >= 768) {
			$("body").toggleClass("enlarged");
			$(this).find("i").toggleClass("fa-arrow-left fa-arrow-right");
		} else {
			$("body").removeClass("enlarged");
		}
        
		// sidebar - scroll container
		//$this._resetSidebarScroll();
		resetSidebarScroll();
	});

	// sidebar - main menu
	$("#side-menu").metisMenu();

	// sidebar - scroll container
	resetSidebarScroll();

	// right side-bar toggle
	$(".right-bar-toggle").on("click", function () {
		$("body").toggleClass("right-bar-enabled");
	});

	$(document).on("click", "body", function (e) {
		if ($(e.target).closest(".right-bar-toggle, .right-bar").length > 0) {
			return;
		}

		if ($(e.target).closest(".left-side-menu, .side-nav").length > 0 || $(e.target).hasClass("button-menu-mobile")
            || $(e.target).closest(".button-menu-mobile").length > 0) {
			return;
		}

		$("body").removeClass("right-bar-enabled");
		$("body").removeClass("sidebar-enable");
		return;
	});

	// activate the menu in left side bar based on url
	$("#side-menu a").each(function () {
		var pageUrl = window.location.href.split(/[?#]/)[0];
		if (this.href == pageUrl) {
			$(this).addClass("active");
			$(this).parent().addClass("mm-active"); // add active to li of the current link
			$(this).parent().parent().addClass("mm-show");
			$(this).parent().parent().prev().addClass("active"); // add active class to an anchor
			$(this).parent().parent().parent().addClass("mm-active");
			$(this).parent().parent().parent().parent().addClass("mm-show"); // add active to li of the current link
			$(this).parent().parent().parent().parent().parent().addClass("mm-active");
		}
	});

	// Topbar - main menu
	$(".navbar-toggle").on("click", function () {
		$(this).toggleClass("open");
		$("#navigation").slideToggle(400);
	});
	// Waves Effect
	Waves.init();

	if(location.pathname === "/Account/Login"){
		console.log("loaded login");
		sessionStorage.removeItem("permissions");
		sessionStorage.removeItem("hasLoggedInSession");
	}
};
//$(document).ready(function () {
//    // Left menu collapse
//    $('.button-menu-mobile').on('click', function (event) {
//        event.preventDefault();
//        $('body').toggleClass('sidebar-enable');
//        if ($(window).width() >= 768) {
//            $('body').toggleClass('enlarged');
//        } else {
//            $('body').removeClass('enlarged');
//        }

//        // sidebar - scroll container
//        //$this._resetSidebarScroll();
//        resetSidebarScroll();
//    });

//    // sidebar - main menu
//    $("#side-menu").metisMenu();

//    // sidebar - scroll container
//    resetSidebarScroll();

//    // right side-bar toggle
//    $('.right-bar-toggle').on('click', function (e) {
//        $('body').toggleClass('right-bar-enabled');
//    });

//    $(document).on('click', 'body', function (e) {
//        if ($(e.target).closest('.right-bar-toggle, .right-bar').length > 0) {
//            return;
//        }

//        if ($(e.target).closest('.left-side-menu, .side-nav').length > 0 || $(e.target).hasClass('button-menu-mobile')
//            || $(e.target).closest('.button-menu-mobile').length > 0) {
//            return;
//        }

//        $('body').removeClass('right-bar-enabled');
//        $('body').removeClass('sidebar-enable');
//        return;
//    });

//    // activate the menu in left side bar based on url
//    $("#side-menu a").each(function () {
//        var pageUrl = window.location.href.split(/[?#]/)[0];
//        if (this.href == pageUrl) {
//            $(this).addClass("active");
//            $(this).parent().addClass("mm-active"); // add active to li of the current link
//            $(this).parent().parent().addClass("mm-show");
//            $(this).parent().parent().prev().addClass("active"); // add active class to an anchor
//            $(this).parent().parent().parent().addClass("mm-active");
//            $(this).parent().parent().parent().parent().addClass("mm-show"); // add active to li of the current link
//            $(this).parent().parent().parent().parent().parent().addClass("mm-active");
//        }
//    });

//    // Topbar - main menu
//    $('.navbar-toggle').on('click', function (event) {
//        $(this).toggleClass('open');
//        $('#navigation').slideToggle(400);
//    });
//    // Waves Effect
//    Waves.init();
//});
